export const validateSortOrderRange = (value) => {
    if (!value || Number(value) < 1 || Number(value) > 32767) {
      return "osfc.messages.validation.hotlinksSortOrderRange";
    }
  };